import { defineStyleConfig } from '@chakra-ui/react';

export const buttonStyles = defineStyleConfig({
  defaultProps: {
    colorScheme: 'primary',
    size: 'md',
  },
});
